import { Box, Stack, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const spinnerWrapperStyles = xcss({
  height: 'size.1000'
});
const loadingTextStyles = xcss({
  fontSize: '1rem',
  color: 'color.text.subtle'
});
export const LoadingSpinner = () => /*#__PURE__*/_jsxs(Stack, {
  alignBlock: "center",
  alignInline: "center",
  space: "space.200",
  xcss: spinnerWrapperStyles,
  children: [/*#__PURE__*/_jsx(Spinner, {
    size: "large"
  }), /*#__PURE__*/_jsx(Box, {
    xcss: loadingTextStyles,
    children: "Loading..."
  })]
});